import React from "react";
import { Box, FormControl, Select, MenuItem, alpha } from "@mui/material";
import { styled } from "@mui/material/styles";

// Modern shadcn-style Select
const StyledSelect = styled(Select)(({ theme }) => ({
  "& .MuiSelect-select": {
    padding: "8px 12px",
    fontSize: "0.875rem",
    borderRadius: "6px",
    border: "1px solid",
    borderColor: theme.palette.divider,
    backgroundColor: theme.palette.background.paper,
    transition: "all 0.2s ease",
    "&:hover": {
      borderColor: theme.palette.primary.main,
    },
    "&:focus": {
      borderColor: theme.palette.primary.main,
      boxShadow: `0 0 0 3px ${alpha(theme.palette.primary.main, 0.1)}`,
    },
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
}));

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  fontSize: "0.875rem",
  padding: "8px 12px",
  "&:hover": {
    backgroundColor: alpha(theme.palette.primary.main, 0.08),
  },
  "&.Mui-selected": {
    backgroundColor: alpha(theme.palette.primary.main, 0.12),
    "&:hover": {
      backgroundColor: alpha(theme.palette.primary.main, 0.16),
    },
  },
}));

const FinOpsFilters = ({ orgAccountMap, selectedOrgCode, selectedAccountNumber, onOrgChange, onAccountChange }) => {
  // Get list of organizations
  const organizations = orgAccountMap ? Object.values(orgAccountMap) : [];
  
  // Get accounts for selected organization
  const selectedOrg = organizations.find(org => org.orgCode === selectedOrgCode);
  const availableAccounts = selectedOrg?.accountNumbers || [];
  const totalAccountsCount = availableAccounts.length;

  return (
    <Box
      sx={{
        display: "flex",
        gap: 1.5,
        alignItems: "center",
        flexWrap: "wrap",
      }}
    >
      <FormControl size="small" sx={{ minWidth: 180 }}>
        <StyledSelect
          value={selectedOrgCode || ""}
          onChange={(e) => onOrgChange(e.target.value)}
          displayEmpty
          renderValue={(selected) => {
            if (!selected) {
              return <Box sx={{ color: "text.secondary" }}>Organization</Box>;
            }
            const org = organizations.find((o) => o.orgCode === selected);
            return org?.orgName || selected;
          }}
        >
          {organizations.map((org) => (
            <StyledMenuItem key={org.orgCode} value={org.orgCode}>
              {org.orgName}
            </StyledMenuItem>
          ))}
        </StyledSelect>
      </FormControl>

      <FormControl size="small" sx={{ minWidth: 160 }} disabled={!selectedOrgCode}>
        <StyledSelect
          value={selectedAccountNumber || ""}
          onChange={(e) => onAccountChange(e.target.value)}
          displayEmpty
          renderValue={(selected) => {
            if (!selected) {
              const label = totalAccountsCount === 1 || totalAccountsCount === 0 ? "Account" : "Accounts";
              const countDisplay = totalAccountsCount > 1 ? ` (${totalAccountsCount})` : totalAccountsCount === 1 ? " (1)" : "";
              return (
                <Box sx={{ color: "text.secondary" }}>
                  {label}{countDisplay}
                </Box>
              );
            }
            return selected;
          }}
        >
          <StyledMenuItem value="">
            <em>All Accounts</em>
          </StyledMenuItem>
          {availableAccounts.map((account) => (
            <StyledMenuItem key={account} value={account}>
              {account}
            </StyledMenuItem>
          ))}
        </StyledSelect>
      </FormControl>
    </Box>
  );
};

export default FinOpsFilters;
